import React, { useState } from 'react';

function Navbar({ onCategorySelect }) {
  const fullLogo = 'Sanro';
  const [showShopMenu, setShowShopMenu] = useState(false);

  const handleCategoryClick = (category) => {
    if (onCategorySelect) {
      onCategorySelect(category);
    }
    setShowShopMenu(false);
    window.location.hash = 'shop';
  };

  return (
    <nav className="navbar">
      <div className="navbar-content">
        <div className="navbar-left">
          <a href="#home" className="nav-link">Home</a>
          <a href="#about" className="nav-link">Sobre nosotros</a>
          <div 
            className="nav-link-dropdown"
            onMouseEnter={() => setShowShopMenu(true)}
            onMouseLeave={() => setShowShopMenu(false)}
          >
            <a href="#shop" className="nav-link" onClick={() => handleCategoryClick(null)}>
              Tienda
            </a>
            {showShopMenu && (
              <div className="dropdown-menu">
                <a href="#shop" onClick={() => handleCategoryClick('aromas')}>Aromas</a>
                <a href="#shop" onClick={() => handleCategoryClick('difusores')}>Difusores</a>
              </div>
            )}
          </div>
        </div>
        
        <div className="logo">
          <svg className="star-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path d="M8 2h8v3h-2v1h2v2h-2v3h-2v3h-2v-3H8v-3H6V6h2V5H6V2h2zm2 3v1h4V5h-4zm0 2v3h4V7h-4z" fill="currentColor" stroke="none"/>
            <rect x="7" y="14" width="10" height="8" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
            <line x1="12" y1="14" x2="12" y2="22" stroke="currentColor" strokeWidth="1.5"/>
          </svg>
          <span className="logo-text">
            {fullLogo.split('').map((char, index) => (
              <span
                key={index}
                className="letter-fade"
                style={{ animationDelay: `${index * 0.08}s` }}
              >
                {char === ' ' ? '\u00A0' : char}
              </span>
            ))}
          </span>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
